import React from 'react';
import { compose } from 'recompose';
import { withLocale } from '../../../hocs/withLocale';
import {
  Fab,
  Grid,
  Typography,
  Paper,
  withStyles,
  Button,
  ListItemText,
} from '@material-ui/core';
import moment from 'moment';
const today = moment.utc().startOf('day');

export const CalendarListV2 = compose(
  withStyles((theme) => ({
    dayBtn: {
      minWidth: theme.spacing(1.5),
    },
    selectedDay: {
      flex: '0.5 0 auto',
      maxWidth: '250px',
      margin: `0 ${theme.spacing(0.5)}px`,
    },
    nextDay: {
      flex: '0 0 auto',
      margin: `0 ${theme.spacing(0.5)}px`,
    },
    root: {
      width: '100%',
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
    },
    footer: {
      padding: `${theme.spacing(1)}px 0`,
      zIndex: 1,
    },
    eventGroup: {
      flex: 1,
    },
    groupNames: {
      marginTop: theme.spacing(1),
    },

    groupName: {
      overflow: 'hidden',
      padding: theme.spacing(1),
    },
    paperNoClasses: {
      padding: theme.spacing(2),
    },
  })),
  withLocale
)(
  class extends React.Component {
    constructor(props) {
      super(props);
      let selectedDate = props.selectedDate;
      if (!selectedDate) {
        let dayIndex;
        if (props.reverse) {
          dayIndex = props.dates.length - 1;
        } else {
          dayIndex = 0;
        }
        selectedDate = props.dates[dayIndex];
      } else {
        if (
          !(
            selectedDate.diff(props.dates[0], 'days') >= 0 &&
            selectedDate.diff(props.dates[props.dates.length - 1], 'days') <= 0
          )
        ) {
          selectedDate = props.dates[0];
        }
      }
      this.state = {
        day: today,
        selectedDay: selectedDate,
      };
    }

    renderDay = () => {
      const date = this.state.selectedDay;
      const dayEvents = this.getDateEvents(date);
      if (dayEvents.length < 1) {
        return (
          <Paper className={this.props.classes.paperNoClasses}>
            <Typography align="center" variant="h5">
              {this.props.translate(
                'manageRegistration.noClassesAvalibleOnTheDate'
              )}
            </Typography>
          </Paper>
        );
      }
      const { classes, renderDate, renderEvent } = this.props;
      const withKeyProp = (component, index) =>
        React.cloneElement(component, { key: index });
      return dayEvents.map((event, index) =>
        withKeyProp(renderEvent(event), index)
      );
    };

    getDateEvents(date) {
      return this.props.events.filter(
        ({ start, end }) =>
          moment(start).isSameOrBefore(date, 'day') &&
          moment(end).isSameOrAfter(date, 'day')
      );
    }

    render = () => {
      const {
        dates,
        onBlockClick,
        loadingEvents,
        unavailableDates,
        clientDomain,
        onTimeSlotSelected,
        onEventClick,
        columns,
        openHours,
        classes,
        localMoment,
        renderDateNavigation,
      } = this.props;
      const { selectedDay } = this.state;
      return (
        <div className={this.props.classes.root}>
          <Paper className={classes.footer}>
            <Grid container justify="space-between" alignItems="stretch">
              {dates.map((date) => {
                return this.renderDateCellHeader(date, selectedDay);
              })}
            </Grid>
          </Paper>
          {this.renderDay()}
        </div>
      );
    };
    changeDay = (day) => {
      this.setState({ selectedDay: day });
    };
    renderDateCellHeader = (date, selectedDay) => {
      const localDate = this.props.localMoment(date);
      const selected =
        date.startOf('day').diff(selectedDay.startOf('day'), 'days') === 0;

      let style = { height: '100%' };

      return (
        <Grid
          item
          xs={1}
          key={`day-grid-${date.toISOString()}`}
          className={
            selected
              ? this.props.classes.selectedDay
              : this.props.classes.nextDay
          }
        >
          <Button
            className={this.props.classes.dayBtn}
            fullWidth={selected}
            style={style}
            variant={selected ? 'outlined' : undefined}
            color={selected ? 'secondary' : undefined}
            onClick={(e) => {
              this.changeDay(date);
            }}
          >
            <ListItemText
              secondary={
                <Typography style={{ fontSize: '10px' }}>
                  {localDate.format('ddd')}
                </Typography>
              }
              primary={localDate.format('DD')}
            />
          </Button>
        </Grid>
      );
    };
  }
);
